import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";
import { IEntitiesSelectedEvent } from "../components/entity-validation-selector";
export function RLEntityQuickSearch() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/entity-search.html"),
        controller: RLEntityQuickSearchController,
        controllerAs: "searchVM",
        scope: {
            charTypeID: "=charTypeId",
            templateID: "=?templateId",
            parentCharTypeID: "=?parentCharTypeId",
            multiSelect: "=?",
            showColumns: "=?",
            tgIDs: "=?tgIds",
            canCreate: "=?",
            newContractUrl: "=?",
            templateGroupIDs: "=?templateGroupIds",
            excludeByEntityID: "=?excludeByEntityId",
            toggleRefresh: "=?",
            direction: "=?",
            isAssociation: "=?",
            showAdvance: "=?",
            isForReporting: "=?",
            rawBulkIds: "=?",
            validateBy: "=?",
            isBasicTabActive: "=?",
            selectedRecIDTitlePairs: "=?selectedRecIdTitlePairs",
            shouldSyncSelectedRecords: "@?",
            excludeRelatedEntities: "=?"
        },
        bindToController: true
    };
    return directive;
}

class RLEntityQuickSearchController {
    static $inject = ["$scope", "$q", "entityService", "notifyService"];

    showColumns: string[];
    templateID: number;
    tgIDs: number[];
    toggleRefresh: boolean;

    multiSelect: boolean;
    keywords: string;
    page: number;
    numFound: number;
    pageCount: number;
    sortField: string;
    sortDir: number;
    itemRows: Models.IEntitySearchDoc[];
    selectedRecords: Models.IEntitySearchDoc[] = [];
    selectedRecord: Models.IEntitySearchDoc;
    initialized: boolean;
    templates: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];
    selectedTemplate: string;
    selectedStatus: string;
    selectedStatuses: string[];
    canCreate: boolean;
    newEntityURL: string;
    charTypeID: number;
    parentCharTypeID: number;
    templateGroupIDs: number[];
    excludeByEntityID: string;
    excludeRelatedEntities: boolean;
    direction: number;
    isAssociation: boolean;
    lockedRows: _.Dictionary<boolean>;
    filterByTemplateIds: number[];

    columnKeys: { [key: string]: string };
    columnNames: { [key: string]: string };
    rowCount: number;
    showAdvance: boolean;
    allChecked: boolean;
    shouldSyncSelectedRecords: boolean = false;

    rawBulkIds: string;  // comma-delimited list of id's to add in bulk

    selected: { [key: number]: boolean };  // do we need this?
    isForReporting: boolean;
    validateBy: number;
    inValidRecIDsOrTitles: string;
    selectedRecIDTitlePairs: Models.IKeyValuePair<number, string>[];
    isPartyConfigured: boolean;  // do we need this?

    isBasicTabActive: boolean;
    openLinkInNewTab: boolean;

    hasAssociatedTemplates: boolean;
    public previousEntityIdsFromAdvancedView: string[] = [];

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private entityService: EntityService, private notifyService: NotifyService) {


    }

    $onInit() {
        this.pageCount = 1;
        this.numFound = 0;
        this.initialized = false;

        this.itemRows = [];
        this.columnNames = {};
        this.columnKeys = {};
        this.templates = [];
        this.statusFacets = [];

        this.lockedRows = {};
        this.filterByTemplateIds = [];

        this.isPartyConfigured = false;
        this.excludeRelatedEntities = true;
        //this.selectedRecIDTitlePairs = [];
        this.selectedRecords = [];
        this.openLinkInNewTab = true;
        this.InitializeFormDefaults();

        this.hasAssociatedTemplates = true;

        // if a templateID was passed in from above
        this.$scope.$watch(() => this.templateID, (newValue, oldValue) => {
            if (newValue != null) {
                this.selectedStatuses = [];
                this.selectedStatuses.push(this.selectedStatus);

                var request: Models.IEntitySearchRequest = {
                    ct: this.charTypeID,
                    k: this.keywords,
                    p: this.page,
                    r: 10,
                    t: this.selectedTemplate,
                    sd: this.sortDir,
                    sf: this.sortField,
                    tgs: this.tgIDs,
                    ee: this.excludeByEntityID,
                    s: this.selectedStatuses
                };

                this.entityService.search(request)
                    .then((results) => {
                        var selectedTemplate = _.find(results.templateFacets, (meta) => meta.key.split("|")[1] == this.templateID.toString());
                    });
            }
        });

        this.$scope.$watchCollection(() => [this.parentCharTypeID, this.charTypeID, this.selectedTemplate, this.selectedStatus, this.templateID, this.direction, this.sortDir, this.sortField, this.rowCount, this.page], (newValue, oldValue) => {
            if (this.parentCharTypeID != null && this.charTypeID > 0) {
                if (this.templateID > 0) {
                    if (this.direction != null && this.direction == 1) {
                        this.entityService.getAssociatedParentTemplatesForTemplate(this.parentCharTypeID, this.templateID, this.charTypeID)
                            .then((result) => {
                                this.filterByTemplateIds = [];
                                this.hasAssociatedTemplates = result.length > 0;
                                _.forEach(result, t => {
                                    this.filterByTemplateIds.push(t.templateID);
                                });
                                if (result.length == 0 && this.templateID != 0) {
                                    this.filterByTemplateIds.push(this.templateID);
                                }
                            })
                            .finally(() => {
                                this.allChecked = false;
                                this.Search();
                            });
                    } else {
                        this.entityService.getAssociatedTemplatesForTemplate(this.parentCharTypeID, this.templateID, this.charTypeID)
                            .then((result) => {
                                this.filterByTemplateIds = [];
                                this.hasAssociatedTemplates = result.length > 0;
                                //If there are no results, set it to the template
                                if (result.length == 0 && this.templateID != 0) {
                                    this.filterByTemplateIds.push(this.templateID);
                                }

                                _.forEach(result, t => {
                                    this.filterByTemplateIds.push(t.templateID);
                                });
                            })
                            .finally(() => {
                                this.allChecked = false;
                                this.Search();
                            });
                    }
                } else {
                    this.allChecked = false;
                    this.Search();
                }
            }
        });

        this.$scope.$watch(() => [this.charTypeID, this.excludeByEntityID, this.direction],
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (this.canCreate) {
                        var isAssociation = this.isAssociation || false;
                        this.entityService.getEntityCreateURL(this.charTypeID, this.excludeByEntityID, isAssociation, this.direction)
                            .then((result) => {
                                if (result.success) {
                                    this.newEntityURL = "";
                                    this.newEntityURL = result.data;
                                }
                            });
                    }
                }
            }, true);

        this.$scope.$watch<string[]>("showColumns",
            (newValue) => {
                if (newValue != null) {
                    this.columnNames = {};
                    this.columnKeys = {};
                    newValue.forEach((v) => {
                        this.columnNames[v] = v.replace(/\_str|\_txt|\_int/gi, "").replace(/\_/g, " ");
                        this.columnKeys[v] = v.toLowerCase();
                    });
                }
            }, true);

        this.$scope.$watch(() => this.toggleRefresh, (newValue, oldValue) => {
            if (newValue != oldValue) {
                if (this.toggleRefresh) {
                    this.ResetForm();
                    this.toggleRefresh = false;
                }
            }
        }, true);

        this.$scope.$watch(() => this.selectedRecords, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.allChecked = this.ShouldCheckSelectAll();
                this.SyncSelectedRecIDTitlePairs();
            }
        }, true);

        this.$scope.$watch(() => this.selectedRecIDTitlePairs, (newValue, oldValue) => {
            if (newValue == null || newValue.length == 0) {
                this.selectedRecords = [];
            }

            if (newValue != null && newValue !== oldValue) {
                this.SyncSelectedRecords();
            }
        }, true);

        this.$scope.$watch(() => this.selectedRecord, (newValue, oldValue) => {
            if (newValue != oldValue && newValue != null) {
                this.selectedRecords = [];
                this.selectedRecords.unshift(newValue);
            }
        }, true);
    }

    private InitializeFormDefaults() {
        this.isBasicTabActive = true;
        this.selected = {};
        if (!this.isForReporting) {
            this.selectedRecIDTitlePairs = [];
            this.selectedRecords = [];
        }
        this.allChecked = false;
        this.page = 1;
        this.rowCount = 10;
        this.keywords = "";
        this.selectedStatus = null;
        this.selectedStatuses = [];
        this.sortField = "";
        this.sortDir = 0;
        this.selectedTemplate = null;
        this.rawBulkIds = "";
        this.validateBy = 0;
        this.inValidRecIDsOrTitles = "";
    }

    ResetForm() {

        var willAutoSearch: boolean = (
            (this.page !== 1)
            || (this.rowCount !== 10)
            || (this.selectedStatus != null)
            || (this.sortField !== "")
            || (this.sortDir !== 0)
            || (this.selectedTemplate != null)
        );

        this.InitializeFormDefaults();

        if (!willAutoSearch) {
            this.Search();
        }
    }

    ToggleAllChecked() {

        this.itemRows.forEach((item: Models.IEntitySearchDoc) => {

            if (this.allChecked) {

                var isAlreadySelected: boolean = this.selectedRecords.some(selectedItem => selectedItem.entityID === item.entityID);
                var isLocked: boolean = this.lockedRows[item.recordID];

                if (!isAlreadySelected && !isLocked) {
                    this.selectedRecords.push(item);
                }
            } else {  // uncheck all
                this.selectedRecords = _.reject(this.selectedRecords, (rec) => rec.entityID === item.entityID);
            }
        });
    }

    private SyncSelectedRecIDTitlePairs() {
        // add when: item is in selectedRecords, and not in selectedRecIDTitlePairs (they selected something new)
        this.selectedRecords.forEach((selectedRecord) => {
            var alreadyExists: boolean = _.any(this.selectedRecIDTitlePairs, (pair) => pair.key === selectedRecord.recordID);
            if (!alreadyExists) {
                this.selectedRecIDTitlePairs.push({
                    key: selectedRecord.recordID,
                    value: selectedRecord.title
                });
            }
        });

        // remove when: an item is in itemRows, and not in selectedRecords (they unchecked something)
        this.itemRows.forEach((itemRow) => {
            var itemExists = _.any(this.selectedRecords, (selectedRecord) => selectedRecord.recordID === itemRow.recordID);
            if (!itemExists) {
                _.remove(this.selectedRecIDTitlePairs, (item) => item.key == itemRow.recordID);
            }
        });
    }

    private SyncSelectedRecords() {
        if (this.shouldSyncSelectedRecords) {
            _.forEach(this.selectedRecIDTitlePairs, (selectedRecIDTitlePair) => {
                var itemAlreadySelected = _.any(this.selectedRecords, (selectedRecord) => selectedRecord.recordID === selectedRecIDTitlePair.key);
                if (!itemAlreadySelected) {
                    var itemPartOfSearchDocs = _.any(this.itemRows, (itemRow) => itemRow.recordID === selectedRecIDTitlePair.key);
                    if (itemPartOfSearchDocs) {
                        this.selectedRecords.push(_.find(this.itemRows, (itemRow) => itemRow.recordID === selectedRecIDTitlePair.key));
                    }
                }
            });
        }
    }

    private ShouldCheckSelectAll(): boolean {

        var hasNonLockedRows: boolean = _.some(this.itemRows, (item: Models.IEntitySearchDoc) => !this.lockedRows[item.recordID]);

        var ret: boolean = hasNonLockedRows && _.every(this.itemRows, (item) =>
            (this.selectedRecords && this.selectedRecords.some((selectedRecord: Models.IEntitySearchDoc) => selectedRecord.entityID === item.entityID))
            ||
            this.lockedRows[item.recordID]
        );

        return ret;
    }

    FormatFacets(facets: Models.IKeyValuePair<string, number>[]): Models.IKeyValuePair<string, string>[] {
        return _(facets).map<Models.IKeyValuePair<string, string>>(
            (kvp) => {

                var value = "";
                var pair = kvp.key.split("|");
                if (pair.length == 2) {
                    value = pair[0] + " (" + kvp.value + ")";
                }
                return { key: kvp.key, value: value, count: kvp.value };
            }).valueOf();
    }

    SearchClick() {
        this.page = 1;
        this.Search();
    }

    Search() {
        this.itemRows = [];
        var lockedRecordCount: number = 0;
        //Get the valid templates for this entity chartype, templateID, and child chartype
        if (this.charTypeID > 0) {

            this.selectedStatuses = [];
            this.selectedStatuses.push(this.selectedStatus);

            //This is only for Reporting (SSRS) where we only show Records for given Template based on what the report parameter looks like.
            if (this.isForReporting) {
                this.filterByTemplateIds = [];
                if (this.templateID > 0) {
                    this.filterByTemplateIds.push(this.templateID);
                }
            }
            var request: Models.IEntitySearchRequest = {
                ct: this.charTypeID,
                k: this.keywords,
                p: this.page,
                r: this.rowCount,
                t: this.selectedTemplate,
                sd: this.sortDir,
                sf: this.sortField,
                tgs: this.templateGroupIDs,
                ere: this.excludeRelatedEntities ? this.excludeByEntityID : "",
                ee: this.excludeByEntityID,
                ftids: this.filterByTemplateIds,
                s: this.selectedStatuses
            };

            var searchingForParentRecords: boolean = false;
            if (this.direction != null && this.direction == 1) {
                searchingForParentRecords = true;
            }

            this.notifyService.startProgress();
            this.entityService.search(request)
                .then((results) => {
                    var promises = [];

                    if (!this.isForReporting) {
                        var recordIDs = results.resultDocs.map(doc => doc.recordID);
                        if (recordIDs.length > 0) {
                            var promise = this.entityService.getEntityStatuses(this.charTypeID, recordIDs)
                                .then(result => {
                                    if (!searchingForParentRecords) {
                                        this.lockedRows = _.transform<Models.IEntityStatus, boolean>(result, function (acc, value, key) { (acc[key] = value.activeIndicator == 0) }, {});
                                    }
                                    else {
                                        this.lockedRows = _.transform<Models.IEntityStatus, boolean>(result, function (acc, value, key) { (acc[key] = value.lockIndicator > 0 || value.activeIndicator == 0) }, {});
                                    }
                                });
                            promises.push(promise);
                        }
                    }

                    return this.$q.all(promises)
                        .then(() => {
                            if (this.hasAssociatedTemplates || this.isForReporting || this.parentCharTypeID == Consts.CharTypeIDs.mock) {
                                this.itemRows = results.resultDocs;
                                this.templates = this.FormatFacets(results.templateFacets);
                                this.statusFacets = this.FormatFacets(results.statusFacets);
                                this.numFound = results.numFound;
                                this.pageCount = results.pageCount;
                            }
                            else {
                                this.itemRows = null;
                                this.templates = null;
                                this.statusFacets = null;
                                this.numFound = 0;
                                this.pageCount = 0;
                            }
                            this.initialized = true;

                            this.isPartyConfigured = _.any(this.itemRows, (i) => {
                                if (!_.isEmpty(i.characteristics["userlabel"])) {
                                    return true;
                                }
                            });

                            if (this.isForReporting) {
                                _.forEach(this.itemRows, (item) => {
                                    if (_.any(this.selectedRecIDTitlePairs, s => s.key == item.recordID)) {
                                        if (!this.selectedRecords.some(rec => rec.recordID === item.recordID)) {
                                            this.selectedRecords.push(item);
                                        }
                                    }
                                });
                            }

                            this.allChecked = this.ShouldCheckSelectAll();
                        });
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    Select(itemRow: Models.IEntitySearchDoc) {
        this.selectedRecords = [];
        this.selectedRecords.unshift(itemRow);
    }

    SortChanged(sortField: string, sortDir: number) {
        this.sortField = sortField;
        this.sortDir = sortDir;
    }

    public selectEntities(event: IEntitiesSelectedEvent): void {
        var newValidatedEntityIdsAndTitles = event.validEntityIdsAndTitles.map(entity => {
            let recordId = Utils.IdBuilder.splitEntityID(entity.entityId).recID;
            return { key: recordId, value: entity.title };
        });

        _.forEach(newValidatedEntityIdsAndTitles, (newPair) => {
            var itemAlreadyExists = _.any(this.selectedRecIDTitlePairs, (selectedPair) => selectedPair.key === newPair.key);
            if (!itemAlreadyExists) {
                this.selectedRecIDTitlePairs.push({
                    key: newPair.key,
                    value: newPair.value
                });
            }
        });

        this.SyncSelectedRecords();
        if (this.shouldSyncSelectedRecords) {
            this.SyncSelectedRecIDTitlePairs();
        }
    }
}
